import "./sass/private.scss";
import { registerFilterSheetHandlers } from "./filtersheet/FilterSheetHandlers";
import { registerFilterSheetTracking } from "./filtersheet/FilterSheetTracking";
import { registerFilterSheetHistory } from "./filtersheet/FilterSheetHistory";
import { registerQuickFilterButtonHandlers } from "./quickfilter/QuickFilterButton";
import registerFilterFormActionsHandlers, { initializeLayoutField } from "./filter/FilterFormActions";
import { SubmitOnChangeListener } from "./filter/SubmitOnChange";
import { initToggles, isActive, isNotActive } from "./toggle/Toggle";
import registerExpanderHandlers from "./expander/Expander";

import "./filter/FilterSection";
import { OverflowBox } from "./overflowBox/OverflowBox";
import { initExperiments } from "./experiment/Experiments";
import { registerFilterSheetEventListeners } from "./filtersheet/FilterSheetEventListeners";
import { registerFilterReloading } from "./multifiltering/init";
import { registerFilterFormSelectAllButtons } from "./filter/form/SelectAllButton";
import { registerSorting } from "./sorting/init";
import { registerRefinementBar } from "./refinementBar/init";
import { registerFilterStuff } from "./filter/init";
import { FilterSection } from "./filter/FilterSection";
import { Slider } from "./filter/slider/Slider";
import registerFilterTracking from "./filter/FilterTracking";
import { FilterlistExpander } from "./filterlistExpander/FilterlistExpander";
import { ChangeCounter } from "./filter/ChangeCounter";
import registerSvelteComponentInitialization from "./filter/SvelteComponentInitialization";
import { registerSveltePopularFacetValuesListeners } from "./filter/SveltePopularFacetValues";
import { registerFilterSectionChangedListener } from "./filter/FilterSectionChangedAction";
import { registerCategoryPathFacet } from "./filter/SvelteFacet";
import { onReady } from "@otto-ec/global-resources/dom";
import { registerOcFilterSheetHandlers } from "./filtersheet/OcFilterSheetHandlers";
import { SizePreferencesCookieStore } from "@otto-ec/heureka-components/facet";
import { CustomRangeInput } from "./filter/slider/CustomRangeInput";
import { registerCategoryPathValuesSelection } from "./categorypath/categoryPath";

onReady.subscribe(() => {
  initToggles();
  initExperiments();

  registerExpanderHandlers();
  OverflowBox.register();
  registerSvelteComponentInitialization();

  Slider.register();
  if (isActive("HEUREKA_1913_MIGRATE_TO_OC_SHEET")) {
    registerFilterSheetTracking();
    FilterSection.register();
    registerOcFilterSheetHandlers();
  } else {
    registerFilterSheetHandlers();
    FilterSection.register();
  }
  registerFilterSheetEventListeners();
  if (isNotActive("HEUREKA_1913_MIGRATE_TO_OC_SHEET")) {
    registerFilterSheetHistory();
    registerFilterSheetTracking();
  }
  registerQuickFilterButtonHandlers();
  registerFilterFormSelectAllButtons();
  registerFilterFormActionsHandlers();
  registerCategoryPathFacet();
  registerFilterStuff();
  FilterlistExpander.register();
  registerSorting();
  SubmitOnChangeListener.register();
  ChangeCounter.register();
  registerSveltePopularFacetValuesListeners();
  registerCategoryPathValuesSelection();
  registerRefinementBar();
  registerFilterTracking();
  registerFilterReloading();
  registerFilterSectionChangedListener();
  if (isActive("HEUREKA_2086_HIDE_RANGE_SELECT_BUTTON")) {
    CustomRangeInput.register();
  }
  SizePreferencesCookieStore.register();

  initializeLayoutField();
});
